import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import blogData from '../data/blogData';
import SEO from './SEO';

const Blogs = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="section">
            <SEO 
                title="Gut Health Stories & Nutrition Tips" 
                description="Explore the latest insights on gut health, probiotics, hydration, and metabolic wellness from the Nouria team."
                canonical="/blogs"
            />
            <div className="container">
                <div className="section-title fade-in">Our Latest Stories</div>
                <div className="section-subtitle fade-in">
                    Insights, tips, and science to help you understand your gut better.
                </div>

                <div className="blog-grid fade-in">
                    {blogData.slice().reverse().map((blog) => (
                        <Link to={`/blogs/${blog.id}`} key={blog.id} className="blog-card-link">
                            <div className="blog-card">
                                <div className="blog-card-image" style={{ backgroundImage: `url(${blog.previewImage})` }}>
                                    {/* Placeholder for no image if needed, handled by CSS or default bg */}
                                </div>
                                <div className="blog-card-content">
                                    <div className="blog-card-meta">
                                        <span className="blog-date">{blog.date}</span>
                                    </div>
                                    <h3 className="blog-card-title">{blog.title}</h3>
                                    <p className="blog-card-summary">{blog.summary}</p>
                                    <div className="blog-card-tags">
                                        {blog.tags.map(tag => (
                                            <span key={tag} className="blog-tag">{tag}</span>
                                        ))}
                                    </div>
                                    <span className="read-more">Read Article &rarr;</span>
                                </div>
                            </div>
                        </Link>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Blogs;
